var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.iconType === 'text')?_c('span',{style:({ color: _vm.dict.icon })},[_vm._v(_vm._s(_vm.dict.name))]):(_vm.iconType === 'badge')?_c('a-badge',{attrs:{"color":_vm.dict.icon,"text":_vm.dict.name}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }